import React, { useState, useEffect, useMemo } from 'react';
import {
  Container, Box, Typography, Paper, TextField, Button, Alert, Chip,
} from '@mui/material';
import axios from 'axios';
import SidebarLayout from '../components/SidebarLayout';

const parseLines = (text: string) =>
  text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);

const VideoManagement = () => {
  const [text, setText] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const lineCount = useMemo(() => parseLines(text).length, [text]);

  const fetchItems = async () => {
    const resp = await axios.get('/api/bili/videos/all');
    if (resp.data.success) {
      const lines = (resp.data.items || []).map((r: { url: string }) => r.url);
      setText(lines.join('\n'));
    }
  };

  useEffect(() => { fetchItems().catch(console.error); }, []);

  const handleSave = async () => {
    const lines = parseLines(text);
    if (lines.length === 0) {
      setMsg('请至少填写一条视频链接');
      setTimeout(() => setMsg(''), 4000);
      return;
    }
    setLoading(true);
    try {
      const items = lines.map((url, i) => ({ url, enabled: true, sort_order: i }));
      await axios.put('/api/bili/videos', { items });
      setMsg(`已保存 ${lines.length} 条视频链接`);
      fetchItems();
    } catch (e: any) {
      setMsg(e.response?.data?.message || '保存失败');
    } finally {
      setLoading(false);
      setTimeout(() => setMsg(''), 4000);
    }
  };

  return (
    <SidebarLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>视频播放列表</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          每行一个 B 站视频链接（或 BV 号）。总控模式从云端拉取；手动模式可在插件本地填写。
        </Typography>
        {msg && <Alert severity={msg.includes('失败') || msg.includes('至少') ? 'error' : 'success'} sx={{ mb: 2 }}>{msg}</Alert>}
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography variant="subtitle2">视频地址</Typography>
            <Chip label={`共 ${lineCount} 条`} size="small" color={lineCount > 0 ? 'primary' : 'default'} variant="outlined" />
          </Box>
          <TextField
            fullWidth multiline minRows={12} maxRows={24}
            placeholder={'https://www.bilibili.com/video/BV1RhKn6PEkG\nBV12G6nBKEWZ'}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, mb: 2 }}>
            空行忽略；保存后覆盖全部列表。
          </Typography>
          <Button variant="contained" onClick={handleSave} disabled={loading}>保存</Button>
        </Paper>
      </Container>
    </SidebarLayout>
  );
};

export default VideoManagement;
